module.exports = __webpack_public_path__ + "static/img/Asset 9.7ee30a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Asset 9.png
// module id = 754
// module chunks = 0